import EditIcon from '@mui/icons-material/Edit';
import { Row, Col, Typography } from 'antd';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AlumlyButton from '../../../components/AlumlyButton';
import { RouteNameEnum } from '../../../enums/routeName';
import { DateTimeUtils } from '../../../utils/dateTime';
import { PathBuilder } from '../../../utils/pathBuilder';
import usePermission from '../../../hooks/usePermission';
import { PermissionEnum } from '../../../enums/permission';

export type AccountDetailT = {
  firstName: string;
  lastName: string;
  email: string;
  mobileNumber: string;
  dateOfBirth: string;
  gender: string;
  identificationNumber: string
  cardExpiryDate: string;
  height: number;
  weight: number;
};
interface AccountDetailCardProps {
  accountDetail: AccountDetailT;
}

const AccountDetailCard: React.FC<AccountDetailCardProps> = (props: AccountDetailCardProps) => {
  const { accountDetail } = props;
  const {
    firstName, lastName, email, mobileNumber, dateOfBirth,
    gender, identificationNumber, cardExpiryDate, height, weight,
  } = accountDetail;
  const navigate = useNavigate();
  const { checkPermission } = usePermission();
  const { id: customerId } = useParams();
  const onClickEdit = (): void => {
    navigate(PathBuilder.buildPath(RouteNameEnum.customer.edit, { params: { id: customerId } }));
  };

  return (
    <div style={{
      padding: 24,
      paddingBottom: 40,
      borderRadius: '12px',
      boxShadow: '2px 2px 27px 0px rgba(0, 0, 0, 0.08)',
    }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography.Title level={4} style={{ fontWeight: 700, margin: 0 }}>Account details</Typography.Title>
        { checkPermission([PermissionEnum.code.customerEdit])
          && (
          <AlumlyButton label="rxvWhite" icon={<EditIcon />} width={200} onClick={onClickEdit}>
            <span style={{ fontWeight: 700 }}>Edit account details</span>
          </AlumlyButton>
          )}
      </div>
      <Row gutter={[8, 16]} style={{ marginTop: 16 }}>
        <Col md={12} xs={24}>
          <Typography.Text type="secondary">First name</Typography.Text>
          <div>{firstName || '-'}</div>
        </Col>
        <Col md={12} xs={24}>
          <Typography.Text type="secondary">Last name</Typography.Text>
          <div>{lastName || '-'}</div>
        </Col>
        <Col md={12} xs={24}>
          <Typography.Text type="secondary">Email</Typography.Text>
          <div style={{ overflowWrap: 'break-word' }}>{email || '-'}</div>
        </Col>
        <Col md={12} xs={24}>
          <Typography.Text type="secondary">Phone number</Typography.Text>
          <div>{mobileNumber || '-'}</div>
        </Col>
        <Col md={12} xs={24}>
          <Typography.Text type="secondary">Date of birth</Typography.Text>
          <div>{DateTimeUtils.format(dateOfBirth, 'DD MMM YYYY') || '-'}</div>
        </Col>
        <Col md={12} xs={24}>
          <Typography.Text type="secondary">Gender</Typography.Text>
          <div>{gender || '-'}</div>
        </Col>
        {/* <Col md={12} xs={24}>
          <Typography.Text type="secondary">ID card/ Passport no.</Typography.Text>
          <div>{identificationNumber || '-'}</div>
        </Col>
        <Col md={12} xs={24}>
          <Typography.Text type="secondary">Expiry date</Typography.Text>
          <div>{DateTimeUtils.format(cardExpiryDate, 'DD MMM YYYY') || '-'}</div>
        </Col> */}
        {/* <Col md={12} xs={24}>
          <Typography.Text type="secondary">Height (cm)</Typography.Text>
          <div>{height || '-'}</div>
        </Col>
        <Col md={12} xs={24}>
          <Typography.Text type="secondary">Weight (kg)</Typography.Text>
          <div>{weight || '-'}</div>
        </Col> */}
      </Row>
    </div>
  );
};

export default AccountDetailCard;
